





















































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { useAdCampaign } from '@/bundles/Ad/composables/useAdCampaign';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { IGetCampaignDto } from '@/bundles/Ad/dto';

import AdCampaignsListTable from '@/bundles/Ad/components/AdCampaignsListTable.vue';
import AdCampaignCreateForm from '@/bundles/Ad/components/AdCampaignCreateForm.vue';

export default defineComponent({
  name: 'AdAdminCampaigns',

  components: {
    AdCampaignsListTable,
    AdCampaignCreateForm,
  },

  setup() {
    const {
      listLoading,
      total,
      campaigns,
      fetch,
    } = useAdCampaign();
    const { tableOptions, pageOffset, optionsChangeEventHandler } = usePagination();
    const queryParams = computed(() => {
      return {
        skip: pageOffset.value,
        take: tableOptions.value.itemsPerPage,
      } as IGetCampaignDto;
    });
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      await fetch(queryParams.value);
    }

    const showCreateForm = ref(false);

    return {
      total,
      tableOptions,
      pageOffset,
      campaigns,
      listLoading,
      showCreateForm,
      optionsChangeEventHandler,
      fetchWrapper
    };
  },
});
